import {connect} from 'react-redux';

import {ChannelTypesEnum} from '../../../../../libs/shared/core/src/models/api/channelCommonTypes';
import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {AppState} from '../../../../store/appState';
import {getFlatChannels} from '../../../../store/data/channels/channelsSelectors';
import {CustomerPortalChannelPickerWrapped} from './customerPortalChannelPicker';

/*
 * Props.
 */

interface CustomerPortalChannelPickerContainerProps {
  channelId?: number;
}

/*
 * Selectors.
 */

function getChannelId(_state: AppState, props: CustomerPortalChannelPickerContainerProps) {
  return props.channelId;
}

const getChannel = createSelector([getChannelId, getFlatChannels], (channelId, channels) =>
  channels.find((channel) => channel.id === channelId),
);

const getCustomerPortalChannels = createSelector([getFlatChannels], (channels) =>
  channels.filter((channel) => channel.type === ChannelTypesEnum.PORTAL),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CustomerPortalChannelPickerContainerProps>()(() => ({
  channel: getChannel,
  availableChannels: getCustomerPortalChannels,
}));

export const CustomerPortalChannelPickerContainer = connect(mapStateToProps)(
  CustomerPortalChannelPickerWrapped,
);
